import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {PersonenTypEnumLabels, SteuerlicheBeratungAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {Component, Input} from '@angular/core';

@Component({
  selector: 'common-ui-person-typ',
  templateUrl: './person-typ.component.html'
})
export class PersonTypComponent extends FormBaseComponent<SteuerlicheBeratungAngaben> {

  @Input()
  public requiredSteuerberater: boolean;

  public personenTypEnum = PersonenTypEnumLabels;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      personenTyp: [this.data?.personenTyp, [
        this.validatorService.conditionalValidator(() =>
          this.requiredSteuerberater === true, this.validatorService.required())
      ]]
    });
  }
}
